<template>
  <div class="rounded shadow-xs">
    <div class="bg-white rounded p-4 lg:px-12 lg:pb-12 lg:pt-8 shadow-lg">
      <div v-if="searchable" class="flex border-b mb-8 pb-4 lg:pb-8 -mx-12">
        <div class="relative w-2/3 px-12 flex">
          <div class="pr-3 py-3 leading-5 text-gray-600">
            <FontAwesomeIcon icon="search" />
          </div>
          <input v-model="search" type="search" class="form-input" @change="applySearch" />
        </div>
      </div>
      <slot name="before" />

      <div class="grid grid-cols-1 gap-1">
        <slot />
      </div>
      <!-- The actual List -->

      <div v-if="meta" class="flex items-center text-sm mt-12 justify-between">
        <p class="flex-auto">
          Showing
          <span class="font-medium">{{ meta.from }}</span>
          to
          <span class="font-medium">{{ meta.to }}</span>
          of
          <span class="font-medium">{{ meta.total }}</span>
        </p>
        <div class="inline-flex">
          <button
            :disabled="($route.query.page || 1) === 1"
            class="inline-flex items-center border px-4 py-2 rounded-l leading-5 relative bg-white hover:bg-blue-600 hover:border-transparent hover:text-white disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-300 focus:outline-none focus:ring ring-blue-500 ring-opacity-50 focus:z-10"
            @click="changePage(meta.current_page - 1)"
          >
            <FontAwesomeIcon icon="angle-left" />
            <span class="inline-flex ml-2">Previous</span>
          </button>
          <button
            :disabled="($route.query.page || 1) === meta.last_page"
            class="inline-flex items-center -ml-px border px-4 py-2 rounded-r leading-5 relative bg-white hover:bg-blue-600 hover:border-transparent hover:text-white disabled:bg-gray-300 disabled:text-gray-600 disabled:border-gray-300 focus:outline-none focus:ring ring-blue-500 ring-opacity-50 focus:z-10"
            @click="changePage(meta.current_page + 1)"
          >
            <span class="inline-flex mr-2">Next</span>
            <FontAwesomeIcon icon="angle-right" />
          </button>
        </div>
      </div>
      <!-- Footer -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'VList',

  props: {
    meta: {
      type: Object,
      default: null,
    },
    searchable: Boolean,
  },

  data() {
    return {
      search: this.$route.query.search || '',
    };
  },

  methods: {
    applySearch() {
      const { currentRoute } = this.$router;

      const { query } = currentRoute;

      const { filter = {} } = query;

      if (filter.search && filter.search === this.search) return;

      this.$router.push({
        ...currentRoute,
        query: {
          ...query,
          filter: {
            ...filter,
            search: this.search,
          },
          page: 1,
        },
      });
    },
    changePage(page) {
      const route = this.$route;
      const { query } = route;

      if ((query.page && query.page === page) || (!query.page && page === 1)) return;

      this.$router.push({
        ...route,
        query: {
          ...query,
          page,
        },
      });
    },
  },
};
</script>
